import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import StatusComp from "../../../components/StatusComp";
import SelectBox from "../../../components/SelectBox";
import { Table } from "../../../components/Table/Table";
import { violations } from "../../redux/api/dummyJson";
import { search_icon } from "../../../assets/imgs";

const CameraCompanyAdmin = () => {
  const [pagination, setPagination] = useState("");

  const violationType = [
    { name: "No_Helmet", id: 1 },
    { name: "No_Shoes", id: 2 },
    { name: "No_Harness", id: 3 },
  ];

  const cameraList = [
    { name: "KNF C001", id: 1 },
    { name: "KNF C002", id: 2 },
    { name: "KNF C003", id: 3 },
    { name: "KNF C004", id: 4 },
    { name: "KNF C005", id: 5 },
    { name: "KNF C006", id: 6 },
    { name: "KNF C007", id: 7 },
    { name: "KNF C008", id: 8 },
    { name: "KNF C009", id: 9 },
    { name: "KNF C010", id: 10 },
  ];
  const [page, setPage] = useState(1);

  const [data, setData] = useState(violations);

  const [types, setTypes] = useState([]);
  const [camTypes, setCamTypes] = useState([]);
  const [selectedType, setSelecetedType] = useState(null);
  const [selecetdCam, setSelectedCam] = useState(null);

  const location = useLocation();
  const { type, datas } = location?.state;

  const navigate = useNavigate();
  const createdAt = moment().format("DD_MM_YYYY,h:mm A");
  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{(page - 1) * 10 + row.index + 1}</p>;
        },
      },
      {
        Header: "Camera ID",
        accessor: "cameraId",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Violation Type",
        accessor: "typeViolation",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Severity",
        accessor: "severity",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
    ],
    [page]
  );
  return (
    <div className="dashRightView ">
      <StatusComp name={"Site Cameras"} />

      {type && (
        <div className="d-flex p-1">
          <div className="col-md-4 p-3">
            <div className="p-2 mb-2">
              <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                Company Name & Code
              </p>
              <input
                className="input-box w-100"
                readOnly
                value={`${datas?.companyName ?? "Ninos"} - ${
                  data?.companyId ?? "N001"
                }`}
              />
            </div>

            <div className="p-2 mb-2">
              <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                Site Name & Code
              </p>
              <input
                className="input-box w-100"
                readOnly
                value={`${datas?.siteName ?? "Robotics"} - ${
                  data?.siteCode ?? "R001"
                }`}
              />
            </div>
          </div>
          <div className="col-md-4 p-3">
            <div className="p-2 mb-2">
              <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                Site Location
              </p>
              <input
                className="input-box w-100"
                readOnly
                value={datas?.siteLocation ?? "Chennai,vadapalani"}
              />
            </div>
            <div className="p-2 mb-2">
              <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                Site Admin
              </p>
              <input
                className="input-box w-100"
                readOnly
                value={datas?.siteAdminName ?? "Shakthivel"}
              />
            </div>
          </div>
          <div className="col-md-4 p-3">
            <div className="p-2 mb-2">
              <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                Admin Created On
              </p>
              <input className="input-box w-100" readOnly value={createdAt} />
            </div>
          </div>
        </div>
      )}

      {type && (
        <div className="col-md-10 p-3 d-flex ac-jb mt-3">
          <div className="p-2 mb-2">
            <button
              className="back-btn px-4"
              onClick={() =>
                navigate("/company-user-report", { state: { type: "company" } })
              }
            >
              View Report
            </button>
          </div>

          <div className="p-2 mb-2">
            <button
              className="back-btn"
              onClick={() => navigate("/company-ind")}
            >
              View Notifications
            </button>
          </div>

          <div className="p-2 mb-2">
            <button
              className="back-btn"
              onClick={() =>
                navigate("/company-slot", { state: { type: "slot" } })
              }
            >
              Slot Days
            </button>
          </div>
          <div className="p-2 mb-2">
            <button
              className="back-btn"
              onClick={() =>
                navigate("/company-admin-alert-types", {
                  state: { type: "slot" },
                })
              }
            >
              Alert Types
            </button>
          </div>
          <div className="p-2 mb-2">
            <button
              className="submit-btn"
              onClick={() =>
                navigate("/company-admin-camera", { state: { type: "slot" } })
              }
            >
              Cameras
            </button>
          </div>
        </div>
      )}

      <div className="d-flex ac-jb">
        <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
          Total:{cameraList.length}
        </h2>

        <div className="col-md-3">
          <label className="form-label">Select Type</label>
          <SelectBox
            arrayData={violationType}
            data={types}
            setData={setTypes}
            selectedOption={selectedType}
            setSelectedOption={setSelecetedType}
            style={true}
          />
        </div>

        <div className="col-md-3 ">
          <label className="form-label">Select Camera</label>
          <SelectBox
            arrayData={cameraList}
            data={camTypes}
            setData={setCamTypes}
            selectedOption={selecetdCam}
            setSelectedOption={setSelectedCam}
            style={true}
          />
        </div>
        <div className="d-flex gap-3">
          <div className="search-input mt-4">
            <input
              type="text"
              placeholder="Search"
              style={{ border: "none", width: "150px" }}
            />
            <img src={search_icon} className="search" />
          </div>
        </div>
      </div>

      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={data}
        show={true}
      />
    </div>
  );
};

export default CameraCompanyAdmin;
